// extracted by mini-css-extract-plugin
var _1 = "Crq3eJ";
var _2 = "lOe5DC";
var _3 = "v9U8Jx";
var _4 = "KyO5fK";
var _5 = "V19_h0";
var _6 = "tHmAFg";
var _7 = "h1jCdC";
var _8 = "oXeWTv";
var _9 = "UB9XGO";
var _a = "g4108V";
export { _1 as "disabled", _2 as "ease-transition", _3 as "gradient-titanic-80", _4 as "linear-transition-05", _5 as "linkButton", _6 as "shadow-medium-titanic", _7 as "shadow-medium-titanic-hover", _8 as "shadow-titanic-1", _9 as "shadow-white", _a as "text" }
